<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4"> Edit Category </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <div class="mb-4">
             

              <v-text-field
                v-model="formData.category_name"
                :rules="[(v) => !!v || 'Category Name is required']"
                label="Category Name"
                variant="outlined"
                density="compact"
                class="mb-2"
                required
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="!valid || loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_category } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "EditCategoryDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "updated"],
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        category_name: "",
      },
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal && this.category) {
        this.loadCategoryData();
      } else if (!newVal) {
        this.resetForm();
      }
    },
    category: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.modelValue) {
          this.loadCategoryData();
        }
      },
    },
  },
  methods: {
    loadCategoryData() {
      if (this.category) {
        this.formData = {
          category_name: this.category.category_name || "",
        };
      }
    },
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        category_name: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;

      try {
        const input = {
          category_id: this.category.category_id || this.category.id || "",
          category_name: this.formData.category_name,
          source:"BMS",
        };

        const response = await client.graphql({
          query: edit_category,
          variables: {
            input: input,
          },
        });

        // console.log(response);
        const responseData = JSON.parse(response.data.edit_category);

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Category updated successfully",
            color: "success",
          };
          this.$emit("updated", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to update category",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error updating category:", error);
        this.snackbar = {
          show: true,
          message:
            error.message || "An error occurred while updating the category",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped>
</style>

